interface ThirdCardProps {
  header: string;
  subheader: string;
  firstState: string;
  secondState: string;
  thirdState: string;
  firstOrders: string;
  secondOrders: string;
  thirdOrders: string;
  firstButton?: string;
  secondButton?: string;
  thirdButton?: string;
  cardContainerClass: string;
  firstCancelled: string;
  secondCancelled: string;
  thirdCancelled: string;
}

const FleetrifyThirdCard = ({
  header,
  subheader,
  firstState,
  secondState,
  thirdState,
  firstOrders,
  secondOrders,
  thirdOrders,
  firstButton,
  secondButton,
  thirdButton,
  firstCancelled,
  secondCancelled,
  thirdCancelled,
  cardContainerClass,
}: ThirdCardProps) => {
  
  const rows = [
    { state: firstState, orders: firstOrders, number: firstButton, cancelled: firstCancelled },
    { state: secondState, orders: secondOrders, number: secondButton, cancelled: secondCancelled },
    { state: thirdState, orders: thirdOrders, number: thirdButton, cancelled: thirdCancelled },
  ];

  return (
    <div
      className={`bg-white hide-scrollbar border border-[#143887CC] w-[50px] rounded-[8px] h-auto overflow-auto min-h-full p-[20px] ${cardContainerClass} flex flex-col`}
    >
      <p className="font-bold">{header}</p>
      <p>{subheader}</p>

    {/* Rendered Details */}
      <div className="space-y-3">
        {rows.map((row, index) => (
          <div key={index} className="flex flex-row justify-between text-[#9A0063] bg-[#FEF6F6] px-4 py-4 rounded-md">
            <div>
              <p className="m-0 font-semibold">{row.state}</p>
              <p className="m-0 text-[10px]">{row.orders}</p>
            </div>
            <div className="text-[12px]">
                <p>{row.number}</p>
                <p className="text-[10px]">{row.cancelled}</p>
                </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FleetrifyThirdCard;
